<template>
  <section class="space-y-8">
    <header>
      <h2 class="text-static-default-hi heading-3">
        {{ i18n(translations.infoTitle) }}
      </h2>
    </header>
    <div class="bg-static-default-low rounded-lg overflow-hidden">
      <RevAccordionItem>
        <template #title>
          {{ i18n(translations.infoQuestion1) }}
        </template>
        <template #body>
          <div class="text-static-default-low">
            {{ i18n(translations.infoResponse1) }}
          </div>
        </template>
      </RevAccordionItem>
      <RevDivider class="mx-24" />

      <RevAccordionItem>
        <template #title>
          {{ i18n(translations.infoQuestion2) }}
        </template>
        <template #body>
          <div class="text-static-default-low">
            {{ i18n(translations.infoResponse2) }}
          </div>
        </template>
      </RevAccordionItem>
      <RevDivider class="mx-24" />

      <RevAccordionItem>
        <template #title>
          {{ i18n(translations.infoQuestion3) }}
        </template>
        <template #body>
          <div class="text-static-default-low">
            {{ i18n(translations.infoResponse3) }}
          </div>
        </template>
      </RevAccordionItem>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevAccordionItem } from '@ds/components/AccordionItem'
import { RevDivider } from '@ds/components/Divider'

import translations from './ServiceDrawerFaq.translations'

const i18n = useI18n()
</script>
